import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request, getInfoLocalStorage } from "../api/config"

const stateFromLocalStorage = getInfoLocalStorage() 

const initialState = {
    isLoading: false,
    isLoadingBalance: false,
    success: false,
    message: null,
    operations: [],
    balance: [],
    isSubmit: false
}

export const getOperations = createAsyncThunk(
    'operations/',
    async (values, thunkAPI) => {
        try {
            const segment = values?.type != null ? String(values.type).toLowerCase().trim() : ''
            if (!segment || segment === 'undefined') {
                return thunkAPI.rejectWithValue('Tipo de operação inválido')
            }
            const res = await request(`operacional/getOperacoes/${segment}`)
            if(res.code === 11) {
                return res.operacoes
            } else {
                return thunkAPI.rejectWithValue('Houve um erro ao retornar as operações')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao retornar as operações')
        }
    }
)

export const getBalance = createAsyncThunk(
    'operations/balance',
    async (values, thunkAPI) => {
        try {
            const segment = values?.type != null ? String(values.type).toLowerCase().trim() : ''
            if (!segment || segment === 'undefined') {
                return thunkAPI.rejectWithValue('Tipo de operação inválido')
            }
            const res = await request(`operacional/getSaldo/${segment}`)
            if(res.code === 51) {
                return res.saldo
            } else {
                return thunkAPI.rejectWithValue('Houve um erro ao carregar os saldos')
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao carregar os saldos')
        }
    }
)

export const getBatsOperations = createAsyncThunk(
    'operations/bats-operacoes',
    async (_, thunkAPI) => {
        try {
            const res = await request('operacional/bats/operacoes')
            if (res.code === 11) {
                return res.operacoes
            }
            return thunkAPI.rejectWithValue('Houve um erro ao retornar as operações BATS')
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao retornar as operações BATS')
        }
    }
)

export const getBatsBalance = createAsyncThunk(
    'operations/bats-saldo',
    async (_, thunkAPI) => {
        try {
            const res = await request('operacional/bats/saldo')
            if (res.code === 51) {
                return res.saldo
            }
            return thunkAPI.rejectWithValue('Houve um erro ao carregar os saldos BATS')
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao carregar os saldos BATS')
        }
    }
)

export const createOperation = createAsyncThunk(
    'operations/create',
    async (values, thunkAPI) => {
        try {
            const id = stateFromLocalStorage.id
            let endpoint
            if (values.type === 'asa') {
                endpoint = 'operacional/updateOperacao'
            } else if (values.type === 'rfy18') {
                endpoint = 'operacional/updateOperacaoRfy18'
            } else if (values.type === 'rfy18-subordinada') {
                endpoint = 'operacional/updateOperacaoRfy18Subordinada'
            } else if (values.type === 'spirit2') {
                endpoint = 'operacional/updateOperacaoSpirit2'
            } else if (values.type === 'spirit3') {
                endpoint = 'operacional/updateOperacaoSpirit3'
            } else if (values.type === 'capex-senior') {
                endpoint = 'operacional/updateOperacaoCapexSenior'
            } else if (values.type === 'capex-sub') {
                endpoint = 'operacional/updateOperacaoCapexSub'
            } else if (values.type === 'bats') {
                endpoint = 'operacional/updateOperacaoBats'
            } else {
                endpoint = 'operacional/updateOperacaoSpirit'
            }
            
            const res = await request(endpoint, 'POST', {
                valorSaida: values.output,
                cotacao: values.quota,
                adminId: id
            })
            if (res.code === 51) {
                return res
            } else {
                return thunkAPI.rejectWithValue(res.message)
            }
        } catch (e) {
            return thunkAPI.rejectWithValue('Houve um erro ao inserir operação')
        }
    }
)

const operationsSlice = createSlice({
    name: 'operations',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getOperations.pending, (state) => {
                state.isLoading = true
                state.operations = []
            })
            .addCase(getOperations.fulfilled, (state, { payload }) => {
                state.isLoading = false
                state.success = true
                state.operations = payload
            })
            .addCase(getOperations.rejected, (state, { payload }) => {
                state.isLoading = false
                state.success = false
                state.message = payload
                state.operations = []
            })
            .addCase(getBalance.pending, (state) => {
                state.isLoadingBalance = true
                state.balance = {}
            })
            .addCase(getBalance.fulfilled, (state, { payload }) => {
                state.isLoadingBalance = false
                state.success = true
                state.balance = payload
            })
            .addCase(getBalance.rejected, (state, { payload }) => {
                state.isLoadingBalance = false
                state.success = false
                state.message = payload
                state.balance = {}
            })
            .addCase(getBatsOperations.pending, (state) => {
                state.isLoading = true
                state.operations = []
            })
            .addCase(getBatsOperations.fulfilled, (state, { payload }) => {
                state.isLoading = false
                state.success = true
                state.operations = payload
            })
            .addCase(getBatsOperations.rejected, (state, { payload }) => {
                state.isLoading = false
                state.success = false
                state.message = payload
                state.operations = []
            })
            .addCase(getBatsBalance.pending, (state) => {
                state.isLoadingBalance = true
                state.balance = {}
            })
            .addCase(getBatsBalance.fulfilled, (state, { payload }) => {
                state.isLoadingBalance = false
                state.success = true
                state.balance = payload
            })
            .addCase(getBatsBalance.rejected, (state, { payload }) => {
                state.isLoadingBalance = false
                state.success = false
                state.message = payload
                state.balance = {}
            })
            .addCase(createOperation.pending, (state) => {
                state.isSubmit = true
            })
            .addCase(createOperation.fulfilled, (state) => {
                state.isSubmit = false
                state.success = true
            })
            .addCase(createOperation.rejected, (state, { payload }) => {
                state.isSubmit = false
                state.success = false
                state.message = payload
            })
    }
})

const { reducer } = operationsSlice

export default reducer